module.exports = __webpack_public_path__ + "img/09-ABITO-ALIMINI-SML--UNITI-LINO--STAMPE-LINO7.a6d4b9b4.jpg";